import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRightsStore } from '@core/user';
import { whenUserRightsSettled } from '@core/user-rights/create-rights-guard';
import { RootRoutes } from '@core/navigation';
import { AuthStore } from '@core/auth';

export const impersonationGuard: CanActivateFn = () => {
  const userRightsStore = inject(UserRightsStore);
  const authStore = inject(AuthStore);
  const router = inject(Router);

  // Always allow access if currently impersonating (to allow stopping impersonation)
  if (authStore.isImpersonated()) {
    return true;
  }

  const currentStatus = userRightsStore.getUserRightsCallStatus();

  if (currentStatus !== 'loaded' && currentStatus !== 'loading') {
    userRightsStore.getUserRights();
  }

  return whenUserRightsSettled(userRightsStore, () => {
    const hasPermission = userRightsStore.canImpersonate();

    if (!hasPermission) {
      router.navigate(RootRoutes.root);
    }

    return hasPermission;
  });
};
